/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  SubscriptionUserControllerApplyPackagePremiumMutationResponse,
  SubscriptionUserControllerApplyPackagePremiumPathParams,
  SubscriptionUserControllerApplyPackagePremium401,
  SubscriptionUserControllerApplyPackagePremium402,
} from '../../types/SubscriptionUserControllerApplyPackagePremium.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { subscriptionUserApplyPackagePremium } from '../../methods/subscriptionUserApplyPackagePremium.ts';
import { useMutation } from '@tanstack/react-query';

export const subscriptionUserApplyPackagePremiumMutationKey = () =>
  [{ url: '/api/user/telegram/subscriptions/package/premium/:productId' }] as const;

export type SubscriptionUserApplyPackagePremiumMutationKey = ReturnType<
  typeof subscriptionUserApplyPackagePremiumMutationKey
>;

/**
 * {@link /api/user/telegram/subscriptions/package/premium/:productId}
 */
export function useSubscriptionUserApplyPackagePremium<TContext>(
  options: {
    mutation?: UseMutationOptions<
      SubscriptionUserControllerApplyPackagePremiumMutationResponse,
      ResponseErrorConfig<
        SubscriptionUserControllerApplyPackagePremium401 | SubscriptionUserControllerApplyPackagePremium402
      >,
      { productId: SubscriptionUserControllerApplyPackagePremiumPathParams['productId'] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? subscriptionUserApplyPackagePremiumMutationKey();

  return useMutation<
    SubscriptionUserControllerApplyPackagePremiumMutationResponse,
    ResponseErrorConfig<
      SubscriptionUserControllerApplyPackagePremium401 | SubscriptionUserControllerApplyPackagePremium402
    >,
    { productId: SubscriptionUserControllerApplyPackagePremiumPathParams['productId'] },
    TContext
  >(
    {
      mutationFn: async ({ productId }) => {
        return subscriptionUserApplyPackagePremium(productId, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
